module.exports = __webpack_public_path__ + "static/work-other-02d7a2306b476cc82c31e92d5861c6ef.jpg";